// The _landing_source property on cart items indicates which landing page added the item, and
// this script removes items that don't match the current page or are marked as gifted.
// _landing_source is added from the paid-social-main.js script when items are added to the cart.
(function () {
  fetch("/cart.js")
    .then((res) => res.json())
    .then((cart) => {
      const updates = {};
      cart.items.forEach((item) => {
        if (
          item.properties &&
          ((item.properties._landing_source &&
            item.properties._landing_source != window.location.pathname) ||
            item.properties._Gifted)
        ) {
          updates[item.key] = 0; // remove this line
        }
      });

      if (Object.keys(updates).length === 0) return;

      console.log("Cart updates to be made:", updates);

      return fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates }),
      });
    })
    .catch(() => {});
})();
